import { get } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const GetAllTransactionSourceDef = () => get(url.TRANSACTION_SOURCE_DEF_GET)